import api from "../API/apiConfig";
export const login = async (email, companyCode, password) => {
  return await api.post("/authentication/login", { email, companyCode, password });
};

export const register = async (name, companyName, email, password, confirmPassword, redirectUrl) => {
  return await api.post("/authentication/register", { name, companyName, email, password, confirmPassword, redirectUrl });
};

export const verifyRegister = async (token) => {
  return await api.get("/authentication/verify-register", { params: { token } });
};

export const forgotPassword = async (email, redirectUrl) => {
  return await api.post("/authentication/forgot-password", { email, redirectUrl });
};

export const verifyForgot = async (token) => {
  return await api.get("/authentication/verify-forgot", { params: { token } });
};

export const resetPassword = async (id, password, newPassword, confirmPassword) => {
  return await api.post(`/authentication/reset-password/${id}`, { password, newPassword, confirmPassword });
};